const NODE_ENV = process.env.NODE_ENV
import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_PUBMOD_API_HOST
/* 获取文章详情 1405703111946932224*/
const getArticle=(param) =>{
  return axios({
    method:'get',
    url:'/mobile/cms/articlewithrelated',
    params:{
      ...param
    }
    
  })
}
/* 获取文章图文直播 */
const getLiveComment=(param) =>{
  return axios({
    method:'get',
    url:'/mobile/cms/searchlivecomment',
    params:{
      ...param,
      tenantId:1,
      pageNo:1,
      pageSize:10
    }
    
  })
}
const getComment = ({articleId, appId}) =>{
return axios({
    method: "get",
    url: `/dx-bridge/get-comment-with-article-super-v2?page=1&limit=10&objectId=${articleId}&tenantId=1&typeId=1`,
  });
}
export {
  getArticle,getLiveComment,getComment
  
}
